import styled from 'styled-components';
import 'styled-system';
import TextBase from './textBase.js';
import 'react-responsive';
import { mobile } from '../../styles/breakpoints.js';
var Large = /*#__PURE__*/styled(TextBase).attrs(function (_ref) {
  var _theme$typographies, _theme$typographies$l, _theme$colors;

  var fontWeight = _ref.fontWeight,
      color = _ref.color,
      theme = _ref.theme;
  return {
    fontSize: '1.25rem',
    fontWeight: fontWeight || (theme === null || theme === void 0 ? void 0 : (_theme$typographies = theme.typographies) === null || _theme$typographies === void 0 ? void 0 : (_theme$typographies$l = _theme$typographies.large) === null || _theme$typographies$l === void 0 ? void 0 : _theme$typographies$l.font_weight) || 400,
    lineHeight: '2.25rem',
    color: color || (theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.text)
  };
}).withConfig({
  displayName: "large__Large",
  componentId: "sc-e3kopp-0"
})(["@media ", "{font-size:1.125rem;line-height:1.75rem;}"], mobile);
export default Large;
export { Large };